import { SocketService } from "../socket.service";
import { InitService } from "@core-services/init.service";
import { TradableService } from "./tradable.service";
import { Derivative } from "@models/derivative/currencies/derivative";
import { DestructorService } from "@core-services/destructor.service";
import { TranslationService } from "@core-services/translation.service";

export abstract class DerivativeService<D extends Derivative> extends TradableService<D> {
	public abstract startSockets(): void;
	public abstract logoUrl(item: D, grayVersion: boolean): string;

	public constructor(
		protected initService: InitService,
		protected destructor: DestructorService,
		protected translationService: TranslationService,
		protected socketService: SocketService,
		name: string
	) {
		super(initService, destructor, socketService, translationService, name);
	}
}
